// Docs: IMPLEMENTATION.md §3.1 (routing).
// The retired üben page (/practice, /practice?tab=create, /create-lesson,
// /drills): its lesson list lives on Heute now, its erstellen tab is the
// Erstellen window there. A navigation that still carries a lesson as router
// state (an old caller) goes straight to that lesson's runner URL.
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { creatorPath, lessonPath } from '../utils/lessonRoutes';

const LegacyPracticeRedirect = () => {
  const location = useLocation();
  const carried = location.state?.currentLesson;
  const carriedId = carried?.id || carried?.lesson_id;
  if (carriedId) {
    return <Navigate to={lessonPath(carriedId)} state={location.state} replace />;
  }
  const tab = new URLSearchParams(location.search).get('tab');
  const wantsCreate =
    location.pathname === '/create-lesson' || tab === 'create' || tab === 'erstellen';
  return <Navigate to={wantsCreate ? creatorPath() : '/'} replace />;
};

export default LegacyPracticeRedirect;
